module.exports = {"workerPath":"/serviceWorker.94a1b4ac.js"};